export default {
      id: "help__geoitems_icon-usage",
      viewBox: "10 0 65.69 77.18",
      url: __webpack_public_path__ + "img/icons.svg#help__geoitems_icon",
      toString: function () {
        return this.url;
      }
    }